'use strict';

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var errcode = require('err-code');

var CIPHER_MODES = {
  16: 'aes-128-ctr',
  32: 'aes-256-ctr'
};

module.exports = function (key) {
  var mode = CIPHER_MODES[key.length];

  if (!mode) {
    var modes = Object.entries(CIPHER_MODES).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];

      return "".concat(k, " (").concat(v, ")");
    }).join(' / ');
    throw errcode(new Error("Invalid key length ".concat(key.length, " bytes. Must be ").concat(modes)), 'ERR_INVALID_KEY_LENGTH');
  }

  return mode;
};